import { render, staticRenderFns } from "./QualificationsHonors.vue?vue&type=template&id=cb3c2656&"
import script from "./QualificationsHonors.vue?vue&type=script&lang=js&"
export * from "./QualificationsHonors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports